export default __webpack_public_path__ + "static/media/Feature6.56f8fa0e.svg";